import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { throttle } from "@obg/global";
import { CORE_ROUTE, CoreState, CoreUiInteractionEvent, UiInteractionAction } from "@obg/ngx.core";
import { RouteAction } from "@obg/ngx.router";
import { TrackingContext, TrackingNavBarAction } from "@obg/ngx.ui.core";

import { NavbarOptions } from "./navbar.model";

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: "header[obg-m-navbar]",
	templateUrl: "./navbar.container.html",
	styleUrls: ["./navbar.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class NavbarContainer {
	@HostBinding("class.obg-m-navbar") hostCssClass = true;

	@Input() titleText: string | undefined;

	@Input() options: NavbarOptions | undefined;

	@Output() back = new EventEmitter();

	homeRoute = CORE_ROUTE.home;
	logoTrackingData = TrackingNavBarAction.Logo;

	constructor(
		private store: Store<CoreState>,
		private uiInteractionAction: UiInteractionAction
	) {}

	@throttle(1000, { leading: true })
	goBack() {
		this.back.emit();
		if (this.options && this.options.preventDefaultBack) {
			return;
		}
		this.store.dispatch(RouteAction.back());
	}

	dispatchUiInteraction(trackingData: string) {
		if (!trackingData) {
			return;
		}
		this.store.dispatch(
			this.uiInteractionAction.emit({
				context: TrackingContext.NavbarInteractionContext,
				event: CoreUiInteractionEvent.Navigate,
				data: {
					ItemClicked: trackingData,
				},
			})
		);
	}
}
